import React from 'react'
import classNames from 'classnames'
import _filter from 'lodash/filter'
import { COLORS } from '../constants'

const TableLabel = (props) => {
  const {
    price,
    status,
    top,
    left,
    visible,
    showReserveButton,
    seatLabelPriceText = 'Price',
    buyerInfo,
    initializeListeners,
    initializeReservationButtonListeners,
    ticketTypeTireRelationsArray,
    tierId,
    isReservedByMe
  } = props

  const showPrice = seatLabelPriceText && price

  const visibleTickets = _filter(ticketTypeTireRelationsArray, {
    ticket_type_tier_id: tierId
  })

  const showDeposit = visibleTickets[0] && visibleTickets[0].ticket_type_deposit
  const showNumberOfGuests = () => {
    if (!visibleTickets[0]) {
      return false
    }

    return (
      visibleTickets[0].ticket_type_min_number_of_guests &&
      visibleTickets[0].ticket_type_max_number_of_guests
    )
  }

  const numberOfGuests = () => {
    const minGuests = visibleTickets[0].ticket_type_min_number_of_guests
    const maxGuests = visibleTickets[0].ticket_type_max_number_of_guests

    if (minGuests && maxGuests && minGuests === maxGuests) {
      return maxGuests + ' Guests'
    } else {
      return minGuests + '-' + maxGuests + ' Guests'
    }
  }

  return visible ? (
    <div
      className='seatLabelContainer'
      style={{ top, left }}
      ref={initializeListeners}
    >
      <div className='seatLabelRect'>
        <div className='seatLabelHeader'>
          <span style={{ marginLeft: '10px' }}>Table Information</span>
        </div>
        <div
          className={classNames({
            'seatLabelContent seatLabelContent-large': showReserveButton,
            seatLabelContent: !showReserveButton
          })}
        >
          <div className='seatLabelRow'>
            {showPrice && (
              <div className='seatLabelItem'>
                <div className='seatLabelItemTitle'>{seatLabelPriceText}</div>
                <div className='seatLabelItemText'>{price}</div>
              </div>
            )}
            <div
              className={classNames({
                'seatLabelItem flex2': showPrice,
                seatLabelItem: !showPrice
              })}
            >
              <div className='seatLabelItemTitle'>Table</div>
              <div className='seatLabelItemText'>
                {visibleTickets[0] ? visibleTickets[0].ticket_type_name : ''}
              </div>
            </div>
          </div>
          <div className='seatLabelRow'>
            {showDeposit && (
              <div className='seatLabelItem'>
                <div className='seatLabelItemTitle'>Deposit</div>
                <div className='seatLabelItemText'>
                  {visibleTickets[0]
                    ? visibleTickets[0].ticket_type_deposit + '%'
                    : ''}
                </div>
              </div>
            )}
            <div
              className={classNames({
                'seatLabelItem flex2': showDeposit,
                seatLabelItem: !showDeposit
              })}
            >
              <div className='seatLabelItemTitle'>Status</div>
              <div
                className='seatLabelItemText'
                style={{
                  color: isReservedByMe
                    ? '#ffa500'
                    : COLORS[status.toUpperCase()]
                }}
              >
                {status.toUpperCase() === 'RESERVED'
                  ? 'Locked for Purchase'
                  : status}
              </div>
            </div>
          </div>
          {showNumberOfGuests() && (
            <div className='seatLabelRow'>
              <div className='seatLabelItem'>
                <div className='seatLabelItemTitle'>Number of Guests</div>
                <div className='seatLabelItemText'>{numberOfGuests()}</div>
              </div>
            </div>
          )}
          {showReserveButton && (
            <div className='seatLabelRow'>
              <div className='seatLabelItem'>
                <button
                  className='seatLabelButton'
                  ref={initializeReservationButtonListeners}
                >
                  Reserve
                </button>
              </div>
            </div>
          )}
        </div>
        {buyerInfo && (
          <div className='seatLabelContent withBuyerInfo'>
            <div className='seatLabelRow'>
              <div className='seatLabelItem flex3'>
                <div className='seatLabelItemTitle'>Buyer</div>
                <div className='seatLabelItemText'>{buyerInfo.name}</div>
              </div>
            </div>
            <div className='seatLabelRow'>
              <div className='seatLabelItem flex3'>
                <div className='seatLabelItemTitle'>Buyer Email</div>
                <div className='seatLabelItemText'>{buyerInfo.email}</div>
              </div>
            </div>
            <div className='seatLabelRow'>
              <div className='seatLabelItem flex3'>
                <div className='seatLabelItemTitle'>Order ID</div>
                <div className='seatLabelItemText'>{buyerInfo.order}</div>
              </div>
              <div className='seatLabelItem flex3'>
                <div className='seatLabelItemTitle'>Ticket Hash</div>
                <div className='seatLabelItemText'>{buyerInfo.ticket}</div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className='seatLabelTriangle' />
    </div>
  ) : null
}

export { TableLabel }
